import { EditorState } from 'draft-js'
import 'draft-js/dist/Draft.css'
import { ComponentProps, FC } from 'react'
import { EditorContext } from './EditorContext'
import { useEditorContext } from './hooks'
import { Root } from './primatives'

interface Props {
  value?: EditorState
  dark?: boolean
}

/**
 * A wrapper component around DraftJS. Accepts an optional contentState object as initial
 * data and the option to display in readOnly mode.
 */
export const Editor: FC<Props & ComponentProps<typeof Root.Wrapper>> = ({
  value,
  dark,
  children,
  ...rest
}) => {
  const editorContext = useEditorContext({ value })

  return (
    <EditorContext.Provider value={{ ...editorContext, dark }}>
      <Root.Wrapper {...rest}>{children}</Root.Wrapper>
    </EditorContext.Provider>
  )
}
